// import isTouchDevice from 'is-touch-device'

export default function loadPolyfills() {
    const fillIntersectionObserver = () =>
        new Promise(resolve => {
            if (
                'IntersectionObserver' in window &&
                'IntersectionObserverEntry' in window &&
                'intersectionRatio' in window.IntersectionObserverEntry.prototype
            ) {
                // Minimal polyfill for Edge 15's lack of `isIntersecting`
                // See: https://github.com/w3c/IntersectionObserver/issues/211
                if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
                    Object.defineProperty(
                        window.IntersectionObserverEntry.prototype,
                        'isIntersecting',
                        {
                            get: function() {
                                return this.intersectionRatio > 0
                            },
                        },
                    )
                }
                resolve()
            } else {
                console.log('Load intersection-observer polyfill')
                require.ensure(['intersection-observer'], function(require) {
                    require('intersection-observer')
                    // console.log('DONE: Load intersection-observer polyfill')
                    resolve()
                })
            }
        })

    // const fillElementClosest = () =>
    //     new Promise(resolve => {
    //         if (
    //             window.Element.prototype &&
    //             typeof window.Element.prototype.closest !== 'function'
    //         ) {
    //             console.log('Load closest')
    //             require.ensure(['element-closest'], function(require) {
    //                 require('element-closest')
    //                 resolve()
    //             })
    //         } else {
    //             resolve()
    //         }
    //     })

    // if (!isTouchDevice()) {
    //   try {
    //     document.body.classList.add('noTouchDevice')
    //   } catch (e) {
    //     console.log('Could not set noTouch class')
    //   }
    // } else {
    //   try {
    //     document.body.classList.add('touchDevice')
    //   } catch (e) {
    //     console.log('Could not set touchDevice class')
    //   }
    // }

    return Promise.all([fillIntersectionObserver()])
}
